import styled from '@emotion/styled'
import { motion } from 'framer-motion'
import React, { useCallback, useEffect, useState } from 'react'

import Modal from '@/components/Modal'
import { BodyType, ipcInvoke, ipcOn } from '@/utils/electron'

export default function Index() {
  const [outState, setOutState] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      ipcInvoke('win', { method: 'setContentProtection' }, true)
      ipcInvoke('win', { method: 'setAlwaysOnTop' }, true, 'screen-saver')
      ipcInvoke('win', { method: 'setIgnoreMouseEvents' }, true)
      // ipcInvoke('win', { method: 'setVisibleOnAllWorkspaces' }, true, {
      //   visibleOnFullScreen: true
      // })
    }, 100)

    ipcOn('msg', onMsg)

    return () => {
      clearTimeout(timer)
    }
  }, [])

  const onMsg = useCallback(async (event: any, result: BodyType, ...args: any[]) => {
    console.log('🚀 ~ onMsg ~ result:', result)
    const { data } = result
    if ('exit' in data) {
      setOutState(true)
      ipcInvoke('win', { method: 'setIgnoreMouseEvents' }, false)
    }
  }, [])

  return (
    <Container className=" w-screen h-screen flex items-center justify-center flex-col bg-[rgba(255,255,255,0)] select-none relative">
      {/* 左上 */}
      <div className=" w-[7px] h-[50px] absolute z-[10] left-0 top-0 bg-[#6ABF4C]"></div>
      <div className=" w-[50px] h-[7px] absolute z-[10] left-0 top-0 bg-[#6ABF4C]"></div>
      {/* 右上 */}
      <div className=" w-[7px] h-[50px] absolute z-[10] right-0 top-0 bg-[#6ABF4C]"></div>
      <div className=" w-[50px] h-[7px]  absolute z-[10] right-0 top-0 bg-[#6ABF4C]"></div>
      {/* 右下 */}
      <div className=" w-[7px] h-[50px] absolute z-[10] right-0 bottom-0 bg-[#6ABF4C]"></div>
      <div className=" w-[50px] h-[7px]  absolute z-[10] right-0 bottom-0 bg-[#6ABF4C]"></div>
      {/* 左下 */}
      <div className=" w-[7px] h-[50px] absolute z-[10] left-0 bottom-0 bg-[#6ABF4C]"></div>
      <div className=" w-[50px] h-[7px]  absolute z-[10] left-0 bottom-0 bg-[#6ABF4C]"></div>
      <Modal
        show={outState}
        title="提示"
        cancel={() => {
          setOutState(false)
          ipcInvoke('win', { method: 'setIgnoreMouseEvents' }, true)
        }}
        confirm={() => {
          setOutState(false)
          ipcInvoke('win', { method: 'setIgnoreMouseEvents' }, true)
          ipcInvoke('win', { sendWinName: 'screenRecordMark', method: 'close' })
          ipcInvoke('win', { sendWinName: 'screenRecordControl', method: 'close' })

          ipcInvoke('custom', {
            method: 'msg',
            toWinName: 'mainWin',
            data: { exit: true }
          })
        }}
        className="rounded-[10px] w-[360px] h-[200px] shadow-glass m-[10px]"
      >
        <div className="p-[20px] text-[#333]">确定结束共享吗？</div>
      </Modal>
    </Container>
  )
}

const Container = styled(motion.div)``
